import { Component, inject, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { ButtonComponent } from '@atoms/button/button.component';
import { ColorTextComponent } from '@atoms/color-text/color-text.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { MapButtonComponent } from '@atoms/map-button/map-button.component';
import { SmallTitleComponent } from '@atoms/small-title/small-title.component';

@Component({
  selector: 'app-contact-bar',
  imports: [TranslateModule, ButtonComponent, ColorTextComponent, IconComponent, MapButtonComponent, SmallTitleComponent],
  templateUrl: './contact-bar.component.html',
  styleUrl: './contact-bar.component.scss',
})
export class ContactBarComponent {
  @Input() title?: string;
  @Input('title-size') titleSize?: 'small' | 'min';
  @Input() description?: string;
  @Input() buttons: 'all' | 'map' = 'all';
  public globals = inject(Globals);
}
